import {Base} from "@/api/Base"

export class ConnectorStartTranscation extends Base {
    path = "connector/startTranscation"
}